import { render, staticRenderFns } from "./chip-comp.vue?vue&type=template&id=3592af11&scoped=true&"
import script from "./chip-comp.vue?vue&type=script&lang=js&"
export * from "./chip-comp.vue?vue&type=script&lang=js&"
import style0 from "./chip-comp.vue?vue&type=style&index=0&id=3592af11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592af11",
  null
  
)

export default component.exports